import { all, takeLatest } from "redux-saga/effects";
import processAction from "../../../../utils/processAction";
import { actionTypes as companyActionTypes } from "./reducer";
import {
  getCompanies as getCompaniesService,
  createCompany as createCompanyService,
  updateCompany as updateCompanyService,
  deleteCompany as deleteCompanyService,
  getCompanyDetails as getCompanyDetailsService
} from "./service";

function* getCompanies({ id, params }) {
  yield processAction({
    params: { id, params },
    service: getCompaniesService,
    success: companyActionTypes.GET_COMPANIES_SUCCESS,
    failed: companyActionTypes.GET_COMPANIES_FAILED
  })
}

function* createCompany({ id, body }) {
  yield processAction({
    params: { id, body },
    service: createCompanyService,
    success: companyActionTypes.CREATE_COMPANY_SUCCESS,
    failed: companyActionTypes.CREATE_COMPANY_FAILED
  })
}

function* updateCompany({ customer_id, company_id, body }) {
  yield processAction({
    params: { customer_id, company_id, body },
    service: updateCompanyService,
    success: companyActionTypes.UPDATE_COMPANY_SUCCESS,
    failed: companyActionTypes.UPDATE_COMPANY_FAILED
  })
}

function* deleteCompany({ customer_id, company_id }) {
  yield processAction({
    params: { customer_id, company_id },
    service: deleteCompanyService,
    success: companyActionTypes.DELETE_COMPANY_SUCCESS,
    faield: companyActionTypes.DELETE_COMPANY_FAILED
  })
}

function* getCompanyDetails({ customer_id, company_id }) {
  yield processAction({
    params: { customer_id, company_id },
    service: getCompanyDetailsService,
    success: companyActionTypes.GET_COMPANY_DETAILS_SUCCESS,
    failed: companyActionTypes.GET_COMPANY_DETAILS_FAILED
  })
}

function* watchCompanies() {
  yield all([
    takeLatest(companyActionTypes.GET_COMPANIES, getCompanies),
    takeLatest(companyActionTypes.CREATE_COMPANY, createCompany),
    takeLatest(companyActionTypes.UPDATE_COMPANY, updateCompany),
    takeLatest(companyActionTypes.DELETE_COMPANY, deleteCompany),
    takeLatest(companyActionTypes.GET_COMPANY_DETAILS, getCompanyDetails)
  ])
}

export default [watchCompanies()]




// WEBPACK FOOTER //
// ./src/modules/company/pages/company/saga.js